import { useState } from "react";
import { WhatsappLogo, X, ArrowSquareOut } from "@phosphor-icons/react";
import { useBrand } from "../context/BrandContext";
import { useAuth } from "../context/AuthContext";

export default function WhatsAppBubble() {
  const brand = useBrand();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const coach = brand.trainer_name || "your coach";
  const [msg, setMsg] = useState("");

  if (!brand.whatsapp_number) return null;

  const digits = brand.whatsapp_number.replace(/[^0-9]/g, "");
  const openWhatsApp = () => {
    const text = msg.trim() || `Hi ${coach}, it's ${user?.name || "a client"} — I have a quick question.`;
    window.open(`https://wa.me/${digits}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
    setOpen(false);
  };

  return (
    <>
      <button
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-6 left-6 z-40 bg-[#25D366] hover:bg-[#1EBE5A] text-white p-4 rounded-full shadow-xl transition-colors"
        title={`Message ${coach} on WhatsApp`}
        data-testid="whatsapp-bubble"
      >
        <WhatsappLogo size={24} weight="fill" />
      </button>

      {open && (
        <div className="fixed bottom-24 left-6 z-50 w-[320px] card-flat bg-[#111] p-5 shadow-2xl border border-white/10" data-testid="whatsapp-popup">
          <div className="flex items-start justify-between gap-2 mb-3">
            <div>
              <div className="font-display text-lg leading-tight">Got a question?</div>
              <div className="text-xs text-zinc-400 mt-1">Message {coach} directly on WhatsApp.</div>
            </div>
            <button onClick={() => setOpen(false)} className="text-zinc-500 hover:text-white" data-testid="whatsapp-popup-close">
              <X size={16} weight="bold" />
            </button>
          </div>
          <textarea
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            rows={3}
            maxLength={500}
            placeholder={`Hi ${coach}, I have a quick question…`}
            className="w-full px-3 py-2 border bg-[#0A0A0A] text-sm mb-3"
            data-testid="whatsapp-message-input"
          />
          <button
            onClick={openWhatsApp}
            className="w-full py-2.5 bg-[#25D366] hover:bg-[#1EBE5A] text-white text-sm font-semibold flex items-center justify-center gap-2 transition-colors"
            data-testid="whatsapp-open-btn"
          >
            <WhatsappLogo size={16} weight="fill" /> Open WhatsApp <ArrowSquareOut size={13} weight="bold" />
          </button>
        </div>
      )}
    </>
  );
}
